/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Assignment All Students Progress Service
 * This service is used to get all students progress for an assignment
 * @file AssignmentAllStudentsProgressService.js
 * @author Gladson Samuel S
 */

import Framework, { BaseService } from '@greenville/framework';
import { AET_STORE_EVENTS } from '../common/Constants';

export default class AssignmentAllStudentsProgressService extends BaseService {
  constructor() {
    super(AET_STORE_EVENTS.ASSIGNMENT_ALL_STUDENTS_PROGRESS_REQUESTED, 'assignmentAllStudentsProgressStatus');
  }

  /**
   * API call for Assignment All Students Progress
   * @param {*} eventName
   * @param {*} eventData
   * @returns {Promise}
   */
  handleEvent(eventName, eventData = {}) {
    const { assignmentId } = eventData;

    return this.getClient('marin').get(`/aet/assignments/${assignmentId}/students/progress`);
  }

  // eslint-disable-next-line class-methods-use-this
  handleResponse(response, eventData = {}) {
    const { assignmentId } = eventData;
    const studentsProgress = response?.data?.students || [];

    Framework.getStoreRegistry().getStore('assignment').setStudentsProgressOfAssignment(assignmentId, studentsProgress);
    Framework.getEventManager().publish(AET_STORE_EVENTS.ASSIGNMENT_ALL_STUDENTS_PROGRESS_COMPLETED, studentsProgress);
  }

  // eslint-disable-next-line class-methods-use-this
  handleError(error) {
    Framework.getEventManager().publish(AET_STORE_EVENTS.ASSIGNMENT_ALL_STUDENTS_PROGRESS_FAILED, error);
  }
}
